var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 358.9 539.7",
    style: {
      enableBackground: "new 0 0 358.9 539.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:url(#Rectangle_84_00000010290201950716559850000000804497157344049590_);}\n\t.st3{opacity:5.200000e-02;enable-background:new    ;}\n\t.st4{fill:none;}\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:7;}\n\t.st6{fill:#FFFFFF;}\n\t.st7{fill:none;stroke:#FFFFFF;stroke-width:7;stroke-linecap:round;}\n\t.st8{opacity:0.112;fill:#FFFFFF;enable-background:new    ;}\n\t.st9{enable-background:new    ;}\n\t.st10{fill:none;stroke:#FFFFFF;stroke-width:6;stroke-linecap:round;}\n\t.st11{fill:none;stroke:#FFFFFF;stroke-width:5;}\n\t.st12{fill:url(#Rectangle_84_00000084517831476714412260000015208411261686334374_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Image",
    transform: "translate(-288.019 -2311)",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_227_1",
    transform: "translate(288.019 2311)",
    className: "st1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_84_00000134229913147980393160000002929378816877714060_",
    gradientUnits: "userSpaceOnUse",
    x1: -33.6363,
    y1: 663.1362,
    x2: -31.7644,
    y2: 665.2429,
    gradientTransform: "matrix(261.31 0 0 -393 8827.1953 261122.2656)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3BBB9C",
      stopOpacity: 0.98
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    style: {
      stopColor: "#08B3D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#25AAE2"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    style: {
      fill: "url(#Rectangle_84_00000134229913147980393160000002929378816877714060_)"
    },
    width: 358.9,
    height: 539.7
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "YoureSureIcon",
    transform: "translate(47.31 31.206)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Face",
    transform: "translate(0 107)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    className: "st3",
    cx: 125.5,
    cy: 316.7,
    rx: 92.7,
    ry: 16.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_28",
    transform: "translate(0.154)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 125.5,
    cy: 159.4,
    r: 107.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 125.5,
    cy: 159.4,
    r: 103
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    className: "st6",
    cx: 176.2,
    cy: 150.1,
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    className: "st6",
    cx: 77.4,
    cy: 150.1,
    r: 11
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    transform: "translate(28.464 50.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    className: "st7",
    x1: 150.5,
    y1: 46.8,
    x2: 167.7,
    y2: 57.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    className: "st7",
    x1: 28.3,
    y1: 57.8,
    x2: 45.5,
    y2: 46.8
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    className: "st8",
    cx: 131.7,
    cy: 164.2,
    r: 94.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    className: "st7",
    x1: 121.2,
    y1: 215.7,
    x2: 129.7,
    y2: 215.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "alert",
    transform: "translate(75.75)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M51.6,71.1l-2-29.6c-0.4-5.8-0.6-9.9-0.6-12.4c0-3.4,0.9-6.1,2.7-8s4.1-2.9,7.1-2.9c3.5,0,5.9,1.2,7.1,3.7 c1.2,2.4,1.8,6,1.8,10.6c0,2.7-0.1,5.5-0.4,8.3l-2.7,30.4c-0.3,3.6-0.9,6.4-1.9,8.3c-0.9,1.9-2.5,2.9-4.7,2.9 c-2.2,0-3.8-0.9-4.6-2.8C52.6,77.7,52,74.9,51.6,71.1z M58.5,111.7c-2.5,0-4.7-0.8-6.6-2.4c-1.9-1.6-2.8-3.9-2.8-6.8 c0-2.5,0.9-4.7,2.7-6.5s4-2.7,6.6-2.7c2.6,0,4.8,0.9,6.6,2.7c1.8,1.8,2.7,4,2.7,6.5c0,2.9-0.9,5.1-2.8,6.8 C63.1,110.8,60.9,111.7,58.5,111.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "exclaimation",
    transform: "translate(-78.596 68.794)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    transform: "translate(-2 -5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    className: "st10",
    x1: 34.1,
    y1: 64.1,
    x2: 34.1,
    y2: 91.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    className: "st10",
    x1: 6.3,
    y1: 64.1,
    x2: 34.1,
    y2: 64.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    className: "st10",
    x1: 6.3,
    y1: 36.3,
    x2: 6.3,
    y2: 64.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    className: "st10",
    x1: 228.4,
    y1: 76.5,
    x2: 203.6,
    y2: 89.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    className: "st10",
    x1: 215.8,
    y1: 51.7,
    x2: 228.4,
    y2: 76.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_27",
    className: "st10",
    x1: 240.5,
    y1: 39.1,
    x2: 215.8,
    y2: 51.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    transform: "translate(166.442 52.686)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_21-2",
    className: "st10",
    x1: 98.4,
    y1: 57,
    x2: 78.7,
    y2: 76.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22-2",
    className: "st10",
    x1: 78.7,
    y1: 57,
    x2: 98.4,
    y2: 76.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_33",
    transform: "translate(16.536 -53)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 37.2,
    cy: 32,
    r: 14.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 37.2,
    cy: 32,
    r: 11
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Image_00000161609965796238709210000010371663287101418376_",
    transform: "translate(-289.473 -2311)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_84_00000060741365285786902250000016735726190317904046_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.8367,
    y1: 2974.1362,
    x2: 257.7086,
    y2: 2976.2429,
    gradientTransform: "matrix(261.314 0 0 -393 -66526.5391 1171656.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3BBB9C",
      stopOpacity: 0.98
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    style: {
      stopColor: "#08B3D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#25AAE2"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84_00000093160815263956866900000009693726869595363506_",
    x: 289.5,
    y: 2311,
    style: {
      fill: "url(#Rectangle_84_00000060741365285786902250000016735726190317904046_)"
    },
    width: 358.9,
    height: 539.7
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "YoureSureIcon_00000166663737663357053270000005252251202984942991_",
    transform: "translate(332.483 2388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Face_00000160153400808519557900000010546387851022571685_",
    transform: "translate(11 32)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow_00000156586892843138617720000013857561481912728705_",
    className: "st3",
    cx: 127.3,
    cy: 305.7,
    rx: 92.7,
    ry: 16.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_28_00000077302068668856623060000003997030521012437640_",
    transform: "translate(-0.464)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 127.8,
    cy: 148.5,
    r: 107.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 127.8,
    cy: 148.5,
    r: 103
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29_00000081638143177734823140000014645306424880082109_",
    className: "st6",
    cx: 178.1,
    cy: 139.2,
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30_00000176746371788721035960000012060099216209395076_",
    className: "st6",
    cx: 79.2,
    cy: 139.2,
    r: 11
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    className: "st7",
    x1: 139.6,
    y1: 204.5,
    x2: 167.1,
    y2: 190.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_131_00000130636609421911605100000010466511172861654428_",
    transform: "translate(28 50.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19_00000085222937486279761180000003918193983260385701_",
    className: "st7",
    x1: 152.8,
    y1: 59.5,
    x2: 170,
    y2: 70.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20_00000156550643964236608710000015854473652908477078_",
    className: "st7",
    x1: 30.6,
    y1: 70.5,
    x2: 47.8,
    y2: 59.5
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31_00000078742369452416596850000015113766143961036452_",
    className: "st8",
    cx: 133.5,
    cy: 153.3,
    r: 94.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "puzzled"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_132_00000044884962151487198730000018337010587464155799_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_21_00000044871507049973969940000003126826412096997517_",
    className: "st10",
    x1: 35.7,
    y1: 28.7,
    x2: 16.1,
    y2: 48.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22_00000059299885255060796490000015601002639910700960_",
    className: "st10",
    x1: 16.1,
    y1: 28.7,
    x2: 35.7,
    y2: 48.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_133_00000182486511954791364170000002981582743720122515_",
    transform: "translate(178 57.686)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_21-2_00000180345855505718286650000009291340597134500228_",
    className: "st10",
    x1: 102.2,
    y1: 50.3,
    x2: 82.5,
    y2: 69.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22-2_00000167354278719059499480000017522047668258380428_",
    className: "st10",
    x1: 82.5,
    y1: 50.3,
    x2: 102.2,
    y2: 69.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_33_00000103231172743606301140000009702450593525868984_",
    transform: "translate(125.536)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 77.3,
    cy: 43.2,
    r: 14.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 77.3,
    cy: 43.2,
    r: 11
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.8b71b71908df778552a59760237e91ed.svg";
export { ForwardRef as ReactComponent };